import type { PointerEvent } from "react";
import type { Action, InputManager } from "../main/InputManager";

function Pad({ input, action, label, className }: { input: InputManager; action: Action; label: string; className: string }) {
  const down = (e: PointerEvent) => {
    e.preventDefault();
    (e.target as HTMLElement).setPointerCapture(e.pointerId);
    input.setTouch(action, true);
  };
  const up = (e: PointerEvent) => {
    e.preventDefault();
    input.setTouch(action, false);
  };
  return (
    <button className={`touch ${className}`} onPointerDown={down} onPointerUp={up} onPointerCancel={up} onContextMenu={(e) => e.preventDefault()} aria-label={label}>
      {label}
    </button>
  );
}

/** On-screen controls for touch devices (§7.1 InputManager). */
export function TouchControls({ input }: { input: InputManager }) {
  return (
    <div className="touch-controls" aria-label="Touch controls">
      <div className="dpad">
        <Pad input={input} action="UP" label="▲" className="up" />
        <Pad input={input} action="LEFT" label="◀" className="left" />
        <Pad input={input} action="RIGHT" label="▶" className="right" />
        <Pad input={input} action="DOWN" label="▼" className="down" />
      </div>
      <div className="meta">
        <Pad input={input} action="SELECT" label="SELECT" className="pill" />
        <Pad input={input} action="START" label="START" className="pill" />
        <Pad input={input} action="FAST_FORWARD" label="»" className="pill" />
      </div>
      <div className="ab">
        <Pad input={input} action="B" label="B" className="b" />
        <Pad input={input} action="A" label="A" className="a" />
      </div>
    </div>
  );
}
